// extracted by mini-css-extract-plugin
export default {"line":"View_line__pPLRV","title":"View_title__8wBtc","tooltip":"View_tooltip__y7hvD","switch":"View_switch__fNzYQ"};